import { Text } from '@hopskipdrive/react-components';

import { NoSuggestionsContainer } from './NoSuggestions.styles';

export const NoSuggestions = () => {
  return (
    <NoSuggestionsContainer data-testid="smartpooling-no-suggestions">
      <Text variant="labelL" fontWeight={500} textColor="secondary-active">
        Creating a new ride series is the most optimal choice for you at the moment.
      </Text>
      <Text variant="labelL" fontWeight={500} textColor="secondary-active" textAlign="center">
        As you continue creating new ride series, you will have more options to choose from. In order to search again
        you can change any parameter from the ride series details.
      </Text>
    </NoSuggestionsContainer>
  );
};
